type MediaImage = {
    id: string;
    type: 'image';
    media: Inspire.Image[];
};

type MediaVideoDto = {
    id: string;
    type: 'video';
    media: Inspire.VideoDto[];
};

export type MediaDto = MediaImage | MediaVideoDto;

export enum CollectionStatus {
    PUBLISHED = 'published',
    DECLINED = 'declined',
    MODERATION = 'moderation',
    DRAFT = 'draft',
}

export interface CollectionDto {
    id: string;
    display_name: string;
    number_of_posts: number;
    preview_items: Array<MediaDto>;
    modifiable: boolean;
    default_collection: boolean;
    is_public: boolean;
    sharing_url: string;
    author?: {
        id: string;
        display_name: string;
        avatar_url: Inspire.Image[];
    };
    status: CollectionStatus;
    is_liked: boolean;
    likes: number;
    footer_data: {
        feed_button_text: string;
    };
}

export type MediaVideoModel = {
    id: string;
    type: 'video';
    media: Inspire.Video[];
};

export type MediaModel = MediaImage | MediaVideoModel;

export interface CollectionModel {
    id: string;
    url: string;
    displayName: string;
    numberOfPosts: number;
    previewItems: MediaModel[];
    modifiable: boolean;
    defaultCollection: boolean;
    isPublic: boolean;
    sharingUrl: string;
    author?: {
        id: string;
        displayName: string;
        avatarUrl: Inspire.Image[];
    };
    status: CollectionStatus;
    isLiked: boolean;
    likes: number;
    footerData?: {
        feedButtonText: string;
    };
}

export type CollectionsDataModel = CollectionModel;

export interface CollectionPersistenceModel {
    id?: string;
    displayName: string;
    isPublic: boolean;
}

export interface CollectionPersistenceDto {
    display_name: string;
    is_public: boolean;
}
